import { useTableActionContext } from '@aibees/elephant/context';
import { Label } from '@aibees/elephant/types/label';
import { useMemo } from 'react';
import { filterLabelsByVisibility } from '../../../utils/filter-labels-by-visibility';

interface UseDisabledClearParams {
  labels: Label[];
  isLabel: boolean;
}

export function useDisabledClear({
  labels,
  isLabel,
}: UseDisabledClearParams): boolean {
  const {
    labels: globalLabels,
    lists: globalLists,
    tabValue,
  } = useTableActionContext();

  return useMemo(() => {
    const array = isLabel ? globalLabels : globalLists;

    const filteredLabels = filterLabelsByVisibility(labels, tabValue);

    if (filteredLabels.length === 0) {
      return true;
    }

    const filteredArray = filterLabelsByVisibility(array, tabValue);

    const labelsIds = filteredLabels.map((x) => x.id);
    const arrayIds = new Set(filteredArray.map((x) => x.id));

    return !labelsIds.some((id) => arrayIds.has(id));
  }, [globalLabels, globalLists, labels, isLabel, tabValue]);
}
